<!-- <button class="drawer-close-btn mat-elevation-z0" mat-mini-fab aria-label="Close">
    <mat-icon>close</mat-icon>
</button> -->

<div class="file-uploader-contents" appDragAndDrop (fileDropped)="onFileDropped($event)" *ngIf="showImageUploader">
    <input type="file" #fileDropRef id="fileDropRef" [multiple]="config?.multiple" [accept]="config?.supportedExtensions"
        (change)="fileBrowseHandler($event)" [appTargetId]="'Attachments input'" />
    <span [ngClass]="config?.icon" style="font-size: 45px;"></span>
    <h4 class="mb-0">{{config?.title}}</h4>
    <h5 class="font-poppins font-11 text-backish-gray mb-0">({{config?.supportedExtensions}})</h5>
    <!-- <h4>or</h4>
    <label for="fileDropRef">upload</label> -->
</div>
<app-uploaded-file-preview class="d-inline-block w-100" [files]="files" [filesCount]="uploadedFiles.length" [isScanForAssets]="isScanForAssets"
    [showImageEditor]="showImageEditor" (delete)="deleteFile($event)" (scanForAsset)="scanForAsset($event)" [showBeforeAfterTag]="showBeforeAfterTag">
</app-uploaded-file-preview>
<!-- <div class="files-list">
    <div class="single-file" *ngFor="let file of files; let i = index">
        <div class="info">
            <h4 class="name">
                {{ file?.name }}
            </h4>
        </div>

        <div class="delete" (click)="deleteFile(i)">
            <mat-icon>delete_forever</mat-icon>
        </div>
    </div>
</div> -->